import { TravelPoints } from '../travels';

import { TicketCompany } from './ticket-company';

const COUNTRY = {
  MX: 'MX',
  US: 'US',
};

const TICKET_TRAVEL_POINTS_FOR_OTHER_COUNTRIES: TravelPoints<TicketCompany> = {
  origin: TicketCompany.SanDiego,
  destination: TicketCompany.Tijuana,
};

const TICKET_TRAVEL_POINTS_FOR_MX: TravelPoints<TicketCompany> = {
  origin: TicketCompany.Tijuana,
  destination: TicketCompany.SanDiego,
};

export const getTicketTravelPoints = (country?: string): TravelPoints<TicketCompany> =>
  country === COUNTRY.MX ? TICKET_TRAVEL_POINTS_FOR_MX : TICKET_TRAVEL_POINTS_FOR_OTHER_COUNTRIES;
